import { endOfMonth } from "date-fns";
import { formatDateForAPI } from "utils/utils";

/**
 * Gets the date range for the last completed financial quarter
 * Financial year: April to March (Q1: Apr-Jun, Q2: Jul-Sep, Q3: Oct-Dec, Q4: Jan-Mar)
 */
export const getLastFinancialQuarterRange = () => {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  
  // Quarter boundaries: [3,5], [6,8], [9,11], [0,2]
  const quarters = [
    [0, 2, year],     // Q4: Jan-Mar
    [3, 5, year],     // Q1: Apr-Jun  
    [6, 8, year],     // Q2: Jul-Sep
    [9, 11, year - 1] // Q3: Oct-Dec (previous year when current is Jan-Mar)
  ];
  
  const quarterIndex = Math.floor((month + 9) % 12 / 3); // Maps months to previous quarter
  const [startMonth, endMonth, quarterYear] = quarters[quarterIndex];
  
  return {
    start_date: formatDateForAPI(new Date(quarterYear, startMonth, 1)),
    end_date: formatDateForAPI(endOfMonth(new Date(quarterYear, endMonth, 1))),
  };
};
